export const Mission = () => {
  return (
    <section
      id="mission"
      data-testid="mission-section"
      className="relative w-full py-16 md:py-24"
      style={{ backgroundColor: "#634F50" }}
    >
      <div className="mx-auto max-w-[1180px] px-6 md:px-10 lg:px-14 text-center">
        <span className="eyebrow text-[#F6F2EC]/70">Our Mission</span>

        <h2
          data-testid="mission-heading"
          className="font-editorial text-[#F6F2EC] text-4xl md:text-5xl lg:text-6xl leading-[1.1] mt-8 md:mt-10 max-w-4xl mx-auto"
        >
          To make luxury fashion more <span className="font-editorial-italic">accessible,</span> circular, and community-driven.
        </h2>

        <p className="mt-10 text-[#F6F2EC]/85 text-lg md:text-xl leading-relaxed font-light max-w-2xl mx-auto">
          We believe in a future where women can express themselves endlessly — without the cost, clutter, or waste of fast fashion.
        </p>
      </div>
    </section>
  );
};
